/**
 * @generated SignedSource<<9107567bc5a7e0e31fa895057c4ceebe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateIntegrationDescriptionInput = {
  description?: string | null | undefined;
  integrationId: any;
};
export type RollbarIntegrationsDialogUpdateDescriptionMutation$variables = {
  input: UpdateIntegrationDescriptionInput;
};
export type RollbarIntegrationsDialogUpdateDescriptionMutation$data = {
  readonly updateIntegrationDescription: {
    readonly error: string | null | undefined;
    readonly integration: {
      readonly description: string | null | undefined;
      readonly id: any;
    } | null | undefined;
  };
};
export type RollbarIntegrationsDialogUpdateDescriptionMutation = {
  response: RollbarIntegrationsDialogUpdateDescriptionMutation$data;
  variables: RollbarIntegrationsDialogUpdateDescriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateIntegrationDescriptionPayload",
    "kind": "LinkedField",
    "name": "updateIntegrationDescription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLIntegration",
        "kind": "LinkedField",
        "name": "integration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RollbarIntegrationsDialogUpdateDescriptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RollbarIntegrationsDialogUpdateDescriptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6b7c153b9892c9b1011628047939fc10",
    "id": null,
    "metadata": {},
    "name": "RollbarIntegrationsDialogUpdateDescriptionMutation",
    "operationKind": "mutation",
    "text": "mutation RollbarIntegrationsDialogUpdateDescriptionMutation(\n  $input: UpdateIntegrationDescriptionInput!\n) {\n  updateIntegrationDescription(input: $input) {\n    integration {\n      id\n      description\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "8fe3e47fbeb420a48edd86207a25bd75";

export default node;
